"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Core = void 0;
const contract_1 = require("@stellar/stellar-sdk/contract");
const contract_engine_1 = require("./contract-engine");
const build_transaction_1 = require("./pipelines/build-transaction");
const classic_sign_requirements_1 = require("./pipelines/classic-sign-requirements");
const classic_transaction_1 = require("./pipelines/classic-transaction");
const fee_bump_1 = require("./pipelines/fee-bump");
const sign_transaction_1 = require("./pipelines/sign-transaction");
const simulate_transaction_1 = require("./pipelines/simulate-transaction");
const soroban_get_transaction_1 = require("./pipelines/soroban-get-transaction");
const soroban_transaction_1 = require("./pipelines/soroban-transaction");
const submit_transaction_1 = require("./pipelines/submit-transaction");
exports.Core = {
    Pipelines: {
        BuildTransaction: build_transaction_1.BuildTransactionPipeline,
        ClassicSignRequirements: classic_sign_requirements_1.ClassicSignRequirementsPipeline,
        ClassicTransaction: classic_transaction_1.ClassicTransactionPipeline,
        FeeBump: fee_bump_1.FeeBumpPipeline,
        SignTransaction: sign_transaction_1.SignTransactionPipeline,
        SimulateTransaction: simulate_transaction_1.SimulateTransactionPipeline,
        SorobanGetTransaction: soroban_get_transaction_1.SorobanGetTransactionPipeline,
        SorobanTransaction: soroban_transaction_1.SorobanTransactionPipeline,
        SubmitTransaction: submit_transaction_1.SubmitTransactionPipeline,
    },
    ContractEngine: contract_engine_1.ContractEngine,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    Spec: contract_1.Spec,
};
